import { UNIT_ABBREVIATIONS } from '../../constants/constants';

export const columns = ({ t }) => [
  {
    title: t('SKU'),
    name: 'sku'
  },
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('Description'),
    name: 'description'
  },
  {
    title: t('Class'),
    name: 'class'
  },
  {
    title: t('NMFC'),
    name: 'nmfc'
  },
  {
    title: t('Subcode'),
    name: 'subcode'
  },
  {
    title: t('Weight'),
    name: 'weight'
  },
  {
    title: t('HazMat?'),
    name: 'isHazMatValue'
  },
  {
    title: t('Status'),
    name: 'status'
  }
];

export const mockedRows = [
  {
    id: '[HC] PRODUCT111',
    classId: '[HC] 50',
    nmfc: '[HC] 123456-33',
    description: '[HC] Lorem ipsum dolor sit amet'
  },
  {
    id: '[HC] PRODUCT112',
    classId: '[HC] 50',
    nmfc: '[HC] 123456-33',
    description: '[HC] Lorem ipsum dolor sit amet'
  },
  {
    id: '[HC] PRODUCT113',
    classId: '[HC] 50',
    nmfc: '[HC] 123456-33',
    description: '[HC] Lorem ipsum dolor sit amet'
  },
  {
    id: '[HC] PRODUCT114',
    classId: '[HC] 50',
    nmfc: '[HC] 123456-33',
    description: '[HC] Lorem ipsum dolor sit amet'
  },
  {
    id: '[HC] PRODUCT115',
    classId: '[HC] 50',
    nmfc: '[HC] 123456-33',
    description: '[HC] Lorem ipsum dolor sit amet'
  }
];

export const formatData = (
  products,
  freightClasses,
  hazMatClasses,
  hazMatPackingGroups
) =>
  products.map(product => ({
    id: product.id,
    rowVersion: product.rowVersion,
    sku: product.sku,
    name: product.name,
    description: product.description,
    packageCount: product.packageCount,
    packageTypeId: product.packageTypeId,
    pieceCount: product.pieceCount,
    isHazMat: product.isHazMat,
    class: product.freightInfo.freightClassId
      ? freightClasses.find(
          freightClass =>
            freightClass.value === product.freightInfo.freightClassId
        ).title
      : '',
    nmfc: product.freightInfo.nmfcItemCode,
    subcode: product.freightInfo.nmfcSubCode,
    weight: product.weightInfo.weight
      ? `${product.weightInfo.weight} ${
          UNIT_ABBREVIATIONS[product.weightInfo.weightUnit]
        }`
      : '--',
    isHazMatValue: product.isHazMat ? 'Yes' : 'No',
    hazMatClass: product.hazMat.hazMatClassId
      ? hazMatClasses.find(
          hazMatClass => hazMatClass.value === product.hazMat.hazMatClassId
        ).title
      : '',
    hazMatPackingGroup: product.hazMat.hazMatPackingGroupId
      ? (hazMatPackingGroups.find(
        hazMatPackingGroup =>
          hazMatPackingGroup.value === product.hazMat.hazMatPackingGroupId
      ) ? hazMatPackingGroups.find(
        hazMatPackingGroup =>
          hazMatPackingGroup.value === product.hazMat.hazMatPackingGroupId
      ).title: '')
      : '',
    hazMat: product.hazMat,
    freightInfo: product.freightInfo,
    weightInfo: product.weightInfo,
    valueInfo: product.valueInfo,
    status: product.active ? 'Active' : 'Inactive',
    active: product.active
  }));

export const tableColumnExtensions = [{ columnName: 'weight', align: 'right' }];

export default {
  columns,
  mockedRows,
  formatData,
  tableColumnExtensions
};
